import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ItemSimuladorFinanceiro } from 'src/app/models/item-simulador-financeiro';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-item-sim-fin-modal',
  templateUrl: './item-sim-fin-modal.component.html',
  styleUrls: ['./item-sim-fin-modal.component.scss']
})
export class ItemSimFinModalComponent implements OnInit {
  simFin: ItemSimuladorFinanceiro;

  public config: PerfectScrollbarConfigInterface = {};

  // construtor
  constructor(public dialogRef: MatDialogRef<ItemSimFinModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private utilitarioService: UtilitarioService) { }

  ngOnInit() {
    this.simFin = this.data.simFin;
  }

  salvar() {
    this.dialogRef.close(this.simFin);
  }

  fechar() {
    this.dialogRef.close();
  }
}
